// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fixed-curation[data-v-248907cb]{display:flex;flex-direction:column}@media(max-width:985px){.fixed-curation[data-v-248907cb]{gap:48px}}@media(min-width:986px){.fixed-curation[data-v-248907cb]{gap:72px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
